var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiteratureLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 124,
    viewBox: "0 0 144 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8896 120.55H136.67V96.2796L143.56 83.3896L124.89 93.6796L85.8896 94.8697V120.55Z",
    fill: "#7950F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4397 87.0199L82.0997 74.9199C84.4097 70.9599 85.7497 66.3599 85.7497 61.4399C85.7497 46.6599 73.7697 34.6699 58.9797 34.6699C44.1897 34.6699 32.2197 46.6599 32.2197 61.4399C32.2197 76.2199 44.1997 88.2099 58.9797 88.2099C65.7897 88.2099 72.0097 85.6599 76.7297 81.4699L87.4397 87.0199Z",
    fill: "#9775FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5496 50.7398C52.7196 48.4898 55.9997 47.3398 60.2896 47.3398C66.0296 47.3398 69.3496 50.6998 69.3496 56.5298V69.9298H63.1796V67.9298C62.1596 69.1198 59.7796 70.1798 57.2197 70.1798C52.3297 70.1798 49.1396 67.3298 49.1396 62.9498C49.1396 60.5198 50.1196 58.7398 52.0296 57.4998C53.9396 56.2698 56.3296 55.6698 59.1796 55.6698C60.8396 55.6698 62.1596 55.8398 63.1796 56.2198C63.2196 54.0098 62.0296 53.0698 59.6096 53.0698C57.2296 53.0698 55.8197 53.5398 53.4797 55.1998L50.5496 50.7398ZM63.1897 62.3598V61.3398C62.2097 60.9598 61.0597 60.7898 59.8297 60.7898C56.9797 60.7898 55.5296 61.5098 55.5296 62.9598C55.5296 64.1498 56.6397 64.8798 58.5097 64.8798C60.5497 64.8698 62.4697 63.7698 63.1897 62.3598Z",
    fill: "#F1ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.03 66.1992C135.98 66.1992 137.56 67.7792 137.56 69.7292C137.56 71.6792 135.98 73.2592 134.03 73.2592H100.31C98.3603 73.2592 96.7803 71.6792 96.7803 69.7292C96.7803 67.7792 98.3603 66.1992 100.31 66.1992H101.49",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.03 66.1992C135.98 66.1992 137.56 67.7792 137.56 69.7292C137.56 71.6792 135.98 73.2592 134.03 73.2592H100.31C98.3603 73.2592 96.7803 71.6792 96.7803 69.7292C96.7803 67.7792 98.3603 66.1992 100.31 66.1992H101.49",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64 18.3597V66.1197H101.49V17.9297",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64 18.3597V66.1197H101.49V17.9297",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.49 12.5296V11.3096H132.66H133.64",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.49 12.5296V11.3096H132.66H133.64",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74 18.3596H99.6003C98.0403 18.3596 96.7803 17.0996 96.7803 15.5396V14.1296C96.7803 12.5696 98.0403 11.3096 99.6003 11.3096H134.73C136.29 11.3096 137.55 12.5696 137.55 14.1296V15.5396C137.56 17.0996 136.3 18.3596 134.74 18.3596Z",
    fill: "#E5DBFF",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28 25.85C104.95 24.73 106.61 23.62 108.28 22.5C108.64 24.19 108.47 25.98 107.8 27.57C108.53 26.52 109.56 25.69 110.74 25.21C110.89 25.91 111.04 26.62 111.18 27.32C112.55 26.25 113.93 25.17 115.3 24.1C115.77 25.58 116.48 26.98 117.39 28.23C118.4 27.54 119.22 26.59 119.74 25.49C119.15 25.91 119.35 26.95 119.99 27.27C120.64 27.59 121.46 27.29 121.93 26.73C122.4 26.17 122.55 25.43 122.61 24.71C122.98 25.98 123.74 27.14 124.77 27.97C125 28.16 125.27 28.34 125.57 28.34C126.59 28.32 126.51 26.54 127.43 26.1C127.16 26.35 127.39 26.85 127.74 26.95C128.09 27.06 128.46 26.92 128.8 26.77C129.55 26.45 130.31 26.14 131.06 25.82",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28 25.85C104.95 24.73 106.61 23.62 108.28 22.5C108.64 24.19 108.47 25.98 107.8 27.57C108.53 26.52 109.56 25.69 110.74 25.21C110.89 25.91 111.04 26.62 111.18 27.32C112.55 26.25 113.93 25.17 115.3 24.1C115.77 25.58 116.48 26.98 117.39 28.23C118.4 27.54 119.22 26.59 119.74 25.49C119.15 25.91 119.35 26.95 119.99 27.27C120.64 27.59 121.46 27.29 121.93 26.73C122.4 26.17 122.55 25.43 122.61 24.71C122.98 25.98 123.74 27.14 124.77 27.97C125 28.16 125.27 28.34 125.57 28.34C126.59 28.32 126.51 26.54 127.43 26.1C127.16 26.35 127.39 26.85 127.74 26.95C128.09 27.06 128.46 26.92 128.8 26.77C129.55 26.45 130.31 26.14 131.06 25.82",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.96 35.1094C106.29 33.8094 106.97 32.5894 107.91 31.6194C108.07 31.4494 108.25 31.2794 108.48 31.2094C109 31.0294 109.59 31.4094 109.82 31.9194C110.05 32.4194 110.03 32.9994 109.99 33.5594C110.74 33.0694 111.55 32.5694 112.44 32.6094C113.33 32.6494 114.22 33.5394 113.91 34.3694C115.13 33.7894 116.36 33.1994 117.58 32.6194C117.05 33.1794 117.57 34.1994 118.31 34.3894C119.06 34.5794 119.83 34.2094 120.48 33.7894C121 33.4494 121.55 32.9294 121.44 32.3194C121.26 32.5994 121.22 32.9594 121.31 33.2694C122.75 33.5194 124.3 33.0794 125.4 32.1194C124.73 32.4094 125.06 33.5594 125.76 33.7694C126.46 33.9694 127.19 33.5794 127.82 33.2094",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.96 35.1094C106.29 33.8094 106.97 32.5894 107.91 31.6194C108.07 31.4494 108.25 31.2794 108.48 31.2094C109 31.0294 109.59 31.4094 109.82 31.9194C110.05 32.4194 110.03 32.9994 109.99 33.5594C110.74 33.0694 111.55 32.5694 112.44 32.6094C113.33 32.6494 114.22 33.5394 113.91 34.3694C115.13 33.7894 116.36 33.1994 117.58 32.6194C117.05 33.1794 117.57 34.1994 118.31 34.3894C119.06 34.5794 119.83 34.2094 120.48 33.7894C121 33.4494 121.55 32.9294 121.44 32.3194C121.26 32.5994 121.22 32.9594 121.31 33.2694C122.75 33.5194 124.3 33.0794 125.4 32.1194C124.73 32.4094 125.06 33.5594 125.76 33.7694C126.46 33.9694 127.19 33.5794 127.82 33.2094",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17 39.8496C106.65 40.7296 107.93 41.0396 108.76 40.4796C109.31 40.1096 109.88 39.3896 110.47 39.6896C110.64 39.7796 110.76 39.9396 110.9 40.0696C111.74 40.8996 113.37 40.6096 113.87 39.5496C114.55 39.8196 114.65 40.8996 115.35 41.0896C115.79 41.1996 116.21 40.8996 116.57 40.6296C117.04 40.2796 117.55 39.9396 118.12 39.8396C118.7 39.7396 119.37 39.9296 119.66 40.4496C119.78 40.6496 119.85 40.9096 120.06 41.0196C120.27 41.1196 120.53 41.0096 120.73 40.8796C121.2 40.5796 121.62 40.1996 121.97 39.7596C122.08 39.6096 122.21 39.4496 122.39 39.4296C122.71 39.3896 122.87 39.7796 123.09 40.0096C123.71 40.6696 124.79 40.0696 125.47 39.4796",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17 39.8496C106.65 40.7296 107.93 41.0396 108.76 40.4796C109.31 40.1096 109.88 39.3896 110.47 39.6896C110.64 39.7796 110.76 39.9396 110.9 40.0696C111.74 40.8996 113.37 40.6096 113.87 39.5496C114.55 39.8196 114.65 40.8996 115.35 41.0896C115.79 41.1996 116.21 40.8996 116.57 40.6296C117.04 40.2796 117.55 39.9396 118.12 39.8396C118.7 39.7396 119.37 39.9296 119.66 40.4496C119.78 40.6496 119.85 40.9096 120.06 41.0196C120.27 41.1196 120.53 41.0096 120.73 40.8796C121.2 40.5796 121.62 40.1996 121.97 39.7596C122.08 39.6096 122.21 39.4496 122.39 39.4296C122.71 39.3896 122.87 39.7796 123.09 40.0096C123.71 40.6696 124.79 40.0696 125.47 39.4796",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.601 45.5301C107.751 44.1001 110.281 44.1801 111.341 45.6601C111.721 44.9901 112.511 44.5801 113.281 44.6301C114.051 44.6901 114.761 45.2101 115.051 45.9201C115.471 45.1501 116.311 44.6201 117.191 44.6001C118.071 44.5701 118.941 45.0401 119.401 45.7901C119.681 45.0401 120.441 44.5001 121.231 44.4701C122.031 44.4401 122.821 44.9301 123.151 45.6601C123.571 44.7001 125.161 44.6101 125.691 45.5101C126.061 45.2901 126.381 44.9901 126.621 44.6501C126.791 45.0401 127.061 45.3901 127.411 45.6401C128.011 45.5301 128.591 45.3401 129.131 45.0601",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.601 45.5301C107.751 44.1001 110.281 44.1801 111.341 45.6601C111.721 44.9901 112.511 44.5801 113.281 44.6301C114.051 44.6901 114.761 45.2101 115.051 45.9201C115.471 45.1501 116.311 44.6201 117.191 44.6001C118.071 44.5701 118.941 45.0401 119.401 45.7901C119.681 45.0401 120.441 44.5001 121.231 44.4701C122.031 44.4401 122.821 44.9301 123.151 45.6601C123.571 44.7001 125.161 44.6101 125.691 45.5101C126.061 45.2901 126.381 44.9901 126.621 44.6501C126.791 45.0401 127.061 45.3901 127.411 45.6401C128.011 45.5301 128.591 45.3401 129.131 45.0601",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.04 51.1693C107.47 52.3393 109.72 52.3493 111.17 51.1993C112.04 51.9993 113.65 51.7293 114.21 50.6793C115.3 52.0293 117.69 51.9693 118.71 50.5693C119.42 52.1693 121.92 52.5393 123.06 51.2093C123.78 52.2493 125.69 52.0093 126.13 50.8193C126.55 51.6393 127.9 51.7293 128.42 50.9693",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.04 51.1693C107.47 52.3393 109.72 52.3493 111.17 51.1993C112.04 51.9993 113.65 51.7293 114.21 50.6793C115.3 52.0293 117.69 51.9693 118.71 50.5693C119.42 52.1693 121.92 52.5393 123.06 51.2093C123.78 52.2493 125.69 52.0093 126.13 50.8193C126.55 51.6393 127.9 51.7293 128.42 50.9693",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.38 56.0998C128.83 56.4598 128.22 56.7798 127.57 56.8298C126.92 56.8798 126.2 56.6198 125.87 56.0398C125.72 56.6298 125.06 56.9198 124.47 57.0198C123.18 57.2498 121.8 56.9998 120.67 56.3198C119.3 57.3298 117.22 57.1898 115.99 56.0098",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.38 56.0998C128.83 56.4598 128.22 56.7798 127.57 56.8298C126.92 56.8798 126.2 56.6198 125.87 56.0398C125.72 56.6298 125.06 56.9198 124.47 57.0198C123.18 57.2498 121.8 56.9998 120.67 56.3198C119.3 57.3298 117.22 57.1898 115.99 56.0098",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9203 18.3698C101.654 18.3698 103.06 16.964 103.06 15.2298C103.06 13.4957 101.654 12.0898 99.9203 12.0898C98.1861 12.0898 96.7803 13.4957 96.7803 15.2298C96.7803 16.964 98.1861 18.3698 99.9203 18.3698Z",
    fill: "#7950F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9203 73.2595C101.654 73.2595 103.06 71.8537 103.06 70.1195C103.06 68.3853 101.654 66.9795 99.9203 66.9795C98.1861 66.9795 96.7803 68.3853 96.7803 70.1195C96.7803 71.8537 98.1861 73.2595 99.9203 73.2595Z",
    fill: "#7950F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2948 0.75832L34.6826 5.15332L39.0776 12.7655L46.6898 8.37046L42.2948 0.75832Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12012 6.62012L33.6201 26.6201",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6402 85.9199L16.6602 95.4499L25.4002 91.5399L17.6402 85.9199Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2389 69.703L4.15137 68.1016L2.5499 72.1891L6.63742 73.7906L8.2389 69.703Z",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3302 97.2696L64.8502 93.3896L64.2402 100.08L70.3302 97.2696Z",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 122.75L47.5 102.75",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12012 116.62L18.6201 109.12",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 29.75L32.38 34.12",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteratureLeftImage);
export default __webpack_public_path__ + "static/media/literatureLeftImage.253268e577d6592a786291100b594c80.svg";
export { ForwardRef as ReactComponent };